var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/arrow-right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.1233 12.9413C9.99667 12.9413 9.87 12.8946 9.77 12.7946C9.57667 12.6013 9.57667 12.2813 9.77 12.0879L13.4633 8.39461L9.77 4.70128C9.57667 4.50794 9.57667 4.18794 9.77 3.99461C9.96333 3.80128 10.2833 3.80128 10.4767 3.99461L14.5233 8.04128C14.7167 8.23461 14.7167 8.55461 14.5233 8.74794L10.4767 12.7946C10.3767 12.8946 10.25 12.9413 10.1233 12.9413Z",
    fill: "url(#paint0_linear_8609_64722)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.0559 8.89453H2.83594C2.5626 8.89453 2.33594 8.66786 2.33594 8.39453C2.33594 8.1212 2.5626 7.89453 2.83594 7.89453H14.0559C14.3293 7.89453 14.5559 8.1212 14.5559 8.39453C14.5559 8.66786 14.3293 8.89453 14.0559 8.89453Z",
    fill: "url(#paint1_linear_8609_64722)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8609_64722",
    x1: 9.625,
    y1: 8.39544,
    x2: 14.6683,
    y2: 8.39544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#053CC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#698ADE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8609_64722",
    x1: 2.33594,
    y1: 8.39453,
    x2: 14.5559,
    y2: 8.39453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#053CC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#698ADE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight2);
export default __webpack_public_path__ + "static/media/right2.8b78e78bec7c8cb0c4253076ee2650a5.svg";
export { ForwardRef as ReactComponent };